
declare let $: any;
declare let com: any;
export class CRSFidoAuthCustomTransport {

    constructor(
        private clientId: string) {
        
    }

    sendRequest(request) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: request.getMethod(),
                url: request.getUrl(),
                headers: this.prepareHeaders(request.getHeaders()),
                data: request.getBodyJson(),
                contentType: "application/json",
                dataType: "json",
                success: (data, statusMessage, jqXHR) => {
                    this.onSuccess(request, jqXHR).then(data=>{
                        resolve(data);
                    }).catch(reject);
                },
                error: (jqXHR, errorString, error) => {
                    this.onError(jqXHR, errorString, error).then((data)=>{resolve(data)}).catch(reject);
                }
            });
        });
    }

    onError(jqXHR: any, errorString: any, error: any): Promise<any> {
        return new Promise((resolve,reject)=>{resolve(jqXHR)});
    }

    onSuccess(request: any, jqXHR: any): Promise<any> {
        let response = new com.ts.mobile.sdk.TransportResponse;
        response.setStatus(jqXHR.status), response.setMethod(request.getMethod()), response.setHeaders(this.extractHeaders(jqXHR.getAllResponseHeaders())), response.setBodyJson(jqXHR.responseText);
        return new Promise((resolve,reject)=>{resolve(response)});
    }

    prepareHeaders(headers) {
        var transformedHeaders = {};
        headers.forEach((header) => {
            transformedHeaders[header.getName()] = header.getValue();
        });

        if (this.clientId) {
            transformedHeaders["client_id"] = this.clientId;
        }
        
        return transformedHeaders;
    }

    extractHeaders(request) {
        return request.trim().split(/[\r\n]+/).map((function(t) {
            var e = t.split(": "),
                n = e.shift(),
                r = e.join(": "),
                o = new com.ts.mobile.sdk.TransportHeader;
            return o.setName(n), o.setValue(r), o
        }))
    }

}